
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "KpiSection",
  props: {
    kpis: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    loaded: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  setup(props) {
    const n = (v: number | undefined) => (v ?? 0).toLocaleString("en-US");

    // stickiness is null when MAU is 0 — i.e. the activity bitmaps don't cover this
    // range, so the value is unknown rather than zero. Render an em dash, never
    // "0.0%", which would read as a confident measurement. Same convention as
    // RetentionSection's formatRate.
    const formatRate = (rate: number | null | undefined) =>
      rate === null || rate === undefined ? "—" : `${(rate * 100).toFixed(1)}%`;

    const cards = computed(() => [
      {
        label: "New users",
        value: n(props.kpis.newUsers),
        hint: `DAU ${n(props.kpis.dau)}`,
        icon: "bi bi-people",
      },
      {
        label: "Stickiness",
        value: formatRate(props.kpis.stickiness),
        hint: `MAU ${n(props.kpis.mau)}`,
        icon: "bi bi-magnet",
      },
      {
        label: "Coupons",
        value: n(props.kpis.coupons),
        hint: `${n(props.kpis.coinsWagered)} coins`,
        icon: "bi bi-ticket-perforated",
      },
      {
        label: "Revenue",
        value: n(props.kpis.revenue),
        hint: `${n(props.kpis.payers)} payers`,
        icon: "bi bi-cash-stack",
      },
    ]);

    return { cards, formatRate };
  },
});
